import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { TextTrackingComponent } from './text-tracking.component';

@Injectable({
  providedIn: 'root',
})
export class TextTrackingService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: TextTrackingComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.textTrackingDeliverable.title',
      deliverableType: EDeliverableType.textTracking,
    });
  }
}
